document.addEventListener("DOMContentLoaded", () => {
    // Ajouter automatiquement les attributs data-video-number
    const videoContainers = document.querySelectorAll('.video-container');
    videoContainers.forEach((container, index) => {
        container.setAttribute('data-video-number', index + 1);
    });

    function checkVideos() {
        const videoContainers = document.querySelectorAll('.video-container');
        
        videoContainers.forEach((videoContainer) => {
            const videoNumber = videoContainer.getAttribute('data-video-number');
            const video = videoContainer.querySelector('video');
            const btnLive = videoContainer.querySelector('.btn-video');
            const blocLiveVideo = videoContainer.querySelector('.video-container__video');

            if (video) {
                const flags = createFlags(); // Crée un nouvel ensemble de flags pour chaque vidéo
                initVideoControls(video, btnLive, blocLiveVideo, videoNumber, flags);
            }
        });
    }

    // Fonction pour créer un nouvel ensemble de flags pour chaque vidéo
    function createFlags() {
        return {
            firstClick: true,
            ignoreAutoplay: true,
            isManualPause: false,
            ignorePause: false
        };
    }

    checkVideos();

    function initVideoControls(video, btnLive, blocLiveVideo, videoNumber, flags) {
        function enableFullscreen() {
            blocLiveVideo.classList.add('fullscreen');
            video.setAttribute('controls', 'controls');
            video.muted = false;  // Désactiver le mode muet après le premier clic
        }

        function disableFullscreen() {
            blocLiveVideo.classList.remove('fullscreen');
            video.muted = true;
        }

        // Vérifie si le bouton vidéo existe avant d'ajouter l'événement
        if (btnLive) {
            btnLive.addEventListener('click', () => {
                if (flags.firstClick) {
                    enableFullscreen();  // Activer le plein écran et désactiver le mode muet après le premier clic
                    flags.firstClick = false;
                    flags.ignoreAutoplay = false;
                } else {
                    if (video.paused) {
                        video.play();
                        flags.isManualPause = false; // Pas une pause manuelle
                    } else {
                        video.pause();
                        flags.isManualPause = true;  // Pause manuelle
                    }
                }
            });
        }

        // Event: play
        video.addEventListener('play', () => {
            if (!flags.ignoreAutoplay) enableFullscreen();
        });

        // Event: pause (seulement si ce n'est pas ignoré)
        video.addEventListener('pause', () => {
            if (!flags.ignorePause) {
                disableFullscreen();
            }
        });

        // Event: volume change (ignorer les pauses déclenchées par le changement de volume)
        video.addEventListener('volumechange', () => {
            flags.ignorePause = true; // Ignorer la pause temporairement lors du changement de volume
            setTimeout(() => { flags.ignorePause = false; }, 100); // Réinitialiser après un court délai
        });

        // Event: full screen change (ignorer les pauses causées par le changement d'état de plein écran)
        video.addEventListener('fullscreenchange', () => {
            flags.ignorePause = true; // Ignorer la pause temporairement lors du changement en plein écran
            setTimeout(() => { flags.ignorePause = false; }, 100); // Réinitialiser après un court délai
        });
    }
});
